import React, { createContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get from localStorage or default to FR
    return localStorage.getItem('elua_language') || 'FR';
  });

  useEffect(() => {
    // Save to localStorage whenever language changes
    localStorage.setItem('elua_language', language);
  }, [language]);

  const changeLanguage = (newLanguage) => {
    if (['FR', 'EN', 'ES'].includes(newLanguage)) {
      setLanguage(newLanguage);
    }
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
